import { AdminSupportTicketsView } from '@/components/tickets/AdminSupportTicketsView';

export function TicketsPage() {
  return (
    <div className="container mx-auto py-2">
      <AdminSupportTicketsView />
      </div>
    );
  }

export default TicketsPage;
